/* eslint-disable */
// @ts-nocheck
import NotificationActions from '../../main/actions/NotificationActions';
import { ReduxAsyncAction } from '../support/utils';
import dash_api from '../support/dash_api';
import { saveAdPartner } from './AdPartnerActions';
import type { AdAccounts } from '../types/adPartnerTypes';
import { isSavedAdAccount } from '../components/PartnerManager/utils';
import { ErrorProvider } from '../../../libraries/branch-tooling-next/Error/ErrorProvider';
const TWITTER_ROUTE = '/v1/twitter';
const errorProvider = new ErrorProvider();
const Authenticate = new ReduxAsyncAction('TWITTER_AUTHENTICATE');
Authenticate.registerRequest(() => {
  return dash_api.get(`${TWITTER_ROUTE}/authenticate`).then((res) => {
    const authorizationUrl = res.data;
    return (window.location.href = authorizationUrl);
  });
});
export const AUTHENTICATE = Authenticate.constants;
export const authenticate = Authenticate.request;
const GetAccounts = new ReduxAsyncAction('TWITTER_GET_ACCOUNTS');
GetAccounts.registerRequest(async (savedAccounts: AdAccounts) => {
  const resp = await dash_api.get(`${TWITTER_ROUTE}/get-accounts`);
  return {
    accounts: resp.data.map((account) => ({ ...account, checked: isSavedAdAccount(account.id, savedAccounts) })),
  };
});
export const GET_ACCOUNTS = GetAccounts.constants;
export const getAccounts = GetAccounts.request;
const ConfigureAccounts = new ReduxAsyncAction('TWITTER_CONFIGURE_ACCOUNTS');
ConfigureAccounts.registerRequest(async (params: { accountIds: string[]; partner: any }) => {
  const { data } = await dash_api.post(`${TWITTER_ROUTE}/configure-accounts`, params);
  return {
    accounts: data,
  };
});
export const CONFIGURE_ACCOUNTS = ConfigureAccounts.constants;
export const configureAccounts = function request(params: { accountIds: string[]; partner: any }) {
  return async (dispatch: any) => {
    try {
      await dispatch(ConfigureAccounts.request(params));
      await dispatch(
        saveAdPartner({
          partner: params.partner,
        })
      );
    } catch (err) {
      await dispatch({
        type: ConfigureAccounts.constants.error,
        error: errorProvider.parse(err).getMessageOrEmpty()?.data,
      });
      NotificationActions.entityError('Failed to configure Twitter');
    }
  };
};
const ResetAccounts = new ReduxAsyncAction('TWITTER_RESET_ACCOUNTS');
ResetAccounts.registerRequest((accountIds: string[]) => {
  return dash_api
    .post(`${TWITTER_ROUTE}/reset-accounts`, {
      accountIds,
    })
    .then(({ data }) => ({
      accounts: data,
    }));
});
export const RESET_ACCOUNTS = ResetAccounts.constants;
export const resetAccounts = ResetAccounts.request;
export const UPDATE_TWITTER_AD_ACCOUNTS = 'UPDATE_TWITTER_AD_ACCOUNTS';
export const updateTwitterAdAccounts = (options: { ids: string[]; checked: boolean }) => ({
  type: UPDATE_TWITTER_AD_ACCOUNTS,
  data: options,
});
